import PropTypes from 'prop-types';

export const spacedPinyinPropType = PropTypes.shape({
  index: PropTypes.number.isRequired,
  span: PropTypes.number.isRequired,
  pinyin: PropTypes.string.isRequired,
});
